import type { ClientType } from 'types'

import styled from 'styled-components'
import copy from 'copy.json'

import Modal from 'components/Modal'
import Button from 'components/Button'
import { PowerBigIcon } from 'icons'

const button = copy.common.button

type Props = {
  isModalOpen: boolean
  onModalClose: () => void
  onModalConfirmation: () => void
  clientType: ClientType
}

export default function ConfirmationActivateClientModal({
  isModalOpen,
  onModalClose,
  onModalConfirmation,
  clientType
}: Props) {
  const title =
    clientType === 'buyer'
      ? copy.buyer.demand_details.modal.activate_client.title
      : copy.seller.offer_details.modal.activate_client.title

  const confirmButtonLabel =
    clientType === 'buyer'
      ? copy.buyer.demand_details.modal.activate_client.button_confirmation
      : copy.seller.offer_details.modal.activate_client.button_confirmation

  return (
    <StyledModal isOpen={isModalOpen} onClose={onModalClose}>
      <PowerBigIcon style={{ color: 'var(--green)' }} />

      <h3>{title}</h3>

      <div className="buttons">
        <Button onClick={onModalConfirmation}>{confirmButtonLabel}</Button>

        <Button secondary onClick={onModalClose}>
          {button.cancel}
        </Button>
      </div>
    </StyledModal>
  )
}

const StyledModal = styled(Modal)`
  max-width: 644px;
  width: 100%;

  h3 {
    font: var(--600-24);
    max-width: 424px;
  }

  .buttons {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    max-width: 312px;
    width: 100%;

    margin-top: 8px;
    margin-bottom: 24px;

    button {
      width: 100%;
    }
  }
`
